import { Link } from "react-router-dom";
import styled from "styled-components";

export const Container = styled.div`
  padding: 0 20px;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  @media only screen and (min-width: 768px) {
    padding: 0 30px;
  }
  @media only screen and (min-width: 1366px) {
    padding: 0 40px;
  }
`;

export const Wrapper = styled.div`
  --white: #ffffff;
  --light-grey: #eeeeee;
  --mid-grey: #cccccc;
  --mid-grey-highlight: #dddddd;
  --dark-grey: #666666;
  --dark-grey-highlight: #888888;
  --green: #7299a6;
  --green-highlight: #8bbcc2;
  --yellow: #febd36;
  --orange: #de6f00;
  --orange-highlight: #f68b1f;
  --danger: #da471f;
  --off-white: #fafafa;
  --border: #e7e7e7;
  -webkit-font-smoothing: antialiased;
  font-family: "Figtree", sans-serif;
  font-optical-sizing: auto;
  font-weight: 300;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  color: var(--dark-grey);
  display: flex;
  flex-direction: column;
  max-width: 1920px;
  width: 100%;
  margin: 0 auto;
  &.main {
    min-height: calc(var(--vh, 1vh) * 100);
    background-color: var(--mid-grey-highlight);
  }
  .content {
    padding-bottom: 50px;
    flex-grow: 1;
  }
  .product-image {
    display: flex;
    border-radius: 5px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
    background-color: var(--white);
  }
  .add-to-cart-info {
    color: #7299a6;
    margin-left: 10px;
  }
  #design-placement {
    background-color: var(--dark-grey);
    opacity: 1;
    div.content {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 8px;
      h3 {
        margin-top: 0;
        font-size: 18px;
        font-weight: 700;
        color: var(--yellow);
      }
      span {
        font-size: 14px;
        font-weight: 300;
      }
    }
  }
  .table-header {
    font-size: 16px;
    display: flex;
    div {
      width: 20%;
    }
    &.products {
      justify-content: space-between;
      border-top: 1px solid var(--border);
      background-color: var(--off-white);
      .product-image-header,
      .product-price-header,
      .product-size-header,
      .product-position-header,
      .product-quantity-header {
        text-align: center;
      }
      .product-image-header {
        width: 20%;
      }
      .product-price-header {
        width: 20%;
      }
      .product-size-header {
        width: 20%;
      }
      .product-position-header {
        width: 25%;
      }
      .product-quantity-header {
        width: 15%;
      }
    }
  }
  .table-body {
    border-top: 1px solid var(--border);
    font-weight: 700;
  }
  &.modal-styles {
    margin: initial;
    .fa-circle-info {
      border-radius: 100%;
      &:focus-visible {
        box-shadow: 0 0 0 2px #ffffff;
        outline: 2px solid var(--orange-highlight);
        outline-offset: 2px;
      }
    }

    .modal-title {
      text-transform: uppercase;
      font-size: 16px;
      letter-spacing: 1px;
      img {
        width: 100px;
      }
    }
    overflow: hidden;
    border-radius: 5px;
    &.return-view {
      .modal-body {
        background-color: var(--border);
      }
    }
    &.order-products {
      .table-body {
        background-color: var(--white);
      }
    }
    @media only screen and (max-width: 767px) {
      border-radius: 0;
      &.order-products {
        height: 100%;
      }
    }
    &.cancel-order {
      @media only screen and (min-width: 576px) and (max-width: 767px) {
        border-radius: 5px;
      }
    }
    &.withPadding {
      .modal-body {
        padding: 20px;
      }
      button {
        &.full-width {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-weight: 700;
          color: var(--white);
          background-color: var(--green);
          padding: 8px 20px;
          border-radius: 5px;
          margin-top: 5px;
          margin-bottom: 5px;
          cursor: pointer;
          text-transform: uppercase;
          border: 0;
        }
        &.no-margins {
          margin: 0 !important;
        }
      }
    }
    .modal-header {
      background-color: var(--green);
      padding: 20px 30px !important;
      color: var(--white);
      border: 0;
      border-radius: 0 !important;
      .btn-close {
        box-shadow: none;
        opacity: 1;
        &:focus-visible {
          outline: 2px solid var(--white);
          filter: none;
          background-color: var(--orange-highlight);
        }
      }
      @media only screen and (max-width: 991px) {
        padding: 20px !important;
      }
    }
    .modal-body {
      padding: 0;
      h2 {
        text-align: center;
      }
    }
    .modal-footer {
      border: 0;
      padding: 0;
      & > * {
        margin-left: 0;
        margin-right: 0;
      }
      &.buttons {
        flex-direction: column;
        align-items: stretch;
      }
    }
    .order-footer {
      border-top: 1px solid var(--border);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price-details {
        display: flex;
        .order-footer-labels {
          display: flex;
          flex-direction: column;
          margin-right: 20px;
          text-align: right;
        }
        .order-footer-values {
          display: flex;
          flex-direction: column;
          font-weight: 700;
        }
      }
    }
    .selectedDesignModal {
      padding: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: var(--off-white);
      & > form {
        width: 45%;
      }
      img {
        width: 100%;
      }
      .selected-design-image {
        position: relative;
        width: 50%;
        height: auto;
        aspect-ratio: 1/1;
        background-color: var(--mid-grey);
        border-radius: 5px;
        .next-button,
        .prev-button {
          height: 30px;
          width: 30px;
          background-color: var(--white);
          color: var(--green);
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 100%;
          cursor: pointer;
          border: none;
        }
        button {
          &:focus-visible {
            outline: 2px solid var(--orange-highlight);
            outline-offset: 2px;
          }
        }
        &:focus-visible {
          border: 1px solid var(--orange-highlight) !important;
          outline: 1px solid var(--orange-highlight);
        }
      }
      @media only screen and (max-width: 991px) {
        padding: 20px;
        flex-direction: column;
        & > form {
          width: 100%;
        }
        & > .selected-design-image {
          width: 100%;
          height: auto;
          margin-bottom: 30px;
        }
      }
    }
    &.navigation {
      border-radius: 0 !important;
      .modal-header {
        background-color: var(--white);
        border-bottom: 0px solid var(--dark-grey-highlight);
        padding-top: 16px !important;
        padding-bottom: 16px !important;
        border-radius: 0 !important;
      }
    }
    .mobile-navigation {
      ul,
      li {
        margin: 0;
        padding: 0;
      }
      li {
        list-style-type: none;
        border-bottom: 1px solid var(--border);
      }
      a {
        padding: 15px 20px;
        display: block;
        cursor: pointer;
        font-weight: 700;
        text-transform: uppercase;
        font-size: 12px;
        &:hover {
          background-color: #f0f0f0;
        }
      }
    }
    .size-badge {
      .size-type {
        display: inline-block !important;
        background-color: var(--yellow) !important;
        color: var(--dark-grey) !important;
        border-radius: 2px !important;
        padding: 0px 6px !important;
        font-weight: 700 !important;
        margin-left: 6px !important;
        margin-right: 0 !important;
        line-height: 150% !important;
        &.reg {
          background-color: var(--green) !important;
          color: var(--white) !important;
        }
      }
    }
    .cancel-modal-content {
      text-align: center;
      padding: 20px;
      span {
        margin-bottom: 20px;
        display: block;
        font-weight: 700;
      }
      button {
        margin: 5px auto 10px;
      }
    }
  }
  h1,
  h2 {
    font-size: 20px;
    font-weight: 700;
    color: var(--dark-grey);
    margin-bottom: 20px;
    &.center {
      text-align: center;
      line-height: 30px;
    }
  }
  h3 {
    font-size: 16px;
    font-weight: 700;
    color: var(--dark-grey);
    margin: 30px 0 10px;
  }
  p {
    @media only screen and (max-width: 767px) {
      font-size: 16px;
      line-height: 26px;
    }
  }
  img.border {
    background-color: var(--white);
    padding: 4%;
    border: 1px solid var(--border) !important;
    border-radius: 5px;
  }
  a {
    text-decoration: none;
    color: var(--dark-grey);
    &.order-history-link {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 1px;
      border-radius: 100px;
      cursor: pointer;
      text-transform: uppercase;
      padding: 2px 15px;
      margin: 5px 0;
      line-height: 22px;
      min-width: 150px;
      background-color: transparent;
      color: var(--dark-grey) !important;
      border: 1px solid var(--dark-grey);

      &:focus-visible {
        border-color: var(--orange-highlight) !important;
        box-shadow: none !important;
        outline-offset: 0 !important;
        border-radius: 100px !important;
        background-color: var(--orange-highlight) !important;
        color: #ffffff !important;
        outline: 2px solid var(--dark-grey) !important;
        outline-offset: 2px !important;
      }
    }
    &.text-link {
      &:focus-visible {
        outline: 2px solid var(--orange-highlight);
        border-radius: 5px;
        background-color: rgba(246, 139, 31, 0.15);
        box-shadow: 0 0 0 10px rgba(246, 139, 31, 0.15);
        outline-offset: 5px;
        color: var(--dark-grey) !important;
      }
    }
  }
  strong {
    font-weight: 700;
  }
  label {
    color: var(--dark-grey);
    font-size: 16px;
    font-weight: 300;
    line-height: 17px;
    margin-bottom: 6px;
  }
  input,
  textarea,
  select {
    color: var(--dark-grey);
    line-height: normal;
    font-weight: 700;
    display: block;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--border);
    outline: none;
    &.quantity {
      width: 70px;
    }
    &:focus {
      border: 1px solid var(--orange-highlight);
      outline: 1px solid var(--orange-highlight);
      box-shadow: none;
    }
    &.is-invalid {
      border: 1px solid var(--danger);
      outline: 1px solid var(--danger);
      background-image: none !important;
      box-shadow: none !important;
      &:focus {
        border: 1px solid var(--danger);
        outline: 2px solid var(--orange-highlight);
        outline-offset: 2px;
      }
    }
  }
  input[type="text"],
  input[type="email"],
  select {
    padding: 15px;
  }
  input[type="checkbox"],
  input[type="radio"] {
    border-color: var(--green) !important;
    width: 1em !important;
    &:focus {
      outline: none !important;
    }
    &:focus-visible {
      outline: 2px solid var(--orange-highlight) !important;
    }
  }
  .form-group {
    text-align: left;
    select,
    input {
      margin-bottom: 20px;
    }
  }
  .sticky {
    position: sticky;
    top: 20px;
  }
  .box-padding {
    position: relative;
    padding: 30px;
    @media only screen and (max-width: 991px) {
      padding: 20px;
    }
  }
  .box-padding-2030 {
    position: relative;
    padding: 20px 30px;
    @media only screen and (max-width: 991px) {
      padding: 20px;
    }
  }
  .notice {
    display: flex;
    font-weight: 700;
    margin-bottom: 30px;
    background-color: var(--green);
    color: #fff;
    border-radius: 5px;
    font-size: 18px;
    overflow: hidden;

    &.error {
      background-color: var(--danger);
    }
    .icon {
      font-size: 24px;
      background-color: var(--dark-grey);
      padding: 0 20px;
      display: flex;
      align-items: center;
      i {
        color: var(--yellow);
      }
    }
    .text {
      padding: 20px;
    }
    span.usps-error-link {
      font-size: 16px;
      font-style: italic;
      font-weight: 300;
      display: block;
    }
    a {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .return-bottom-bar {
    margin-top: 20px;
    &.shipping-fee,
    &.sales-tax {
      background-color: #f0f0f0;
      color: var(--dark-grey);
      margin-bottom: 10px;
    }
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 20px;
    font-size: 18px;
    background-color: var(--danger);
    color: var(--white);
    font-weight: 700;
    border-radius: 5px;
    text-align: right;
    span.text {
      font-size: 14px;
      font-style: italic;
      font-weight: 300;
      margin-right: 20px;
    }
    span.amount {
      font-size: 18px;
      font-weight: 700;
    }
    @media only screen and (max-width: 991px) {
      flex-wrap: wrap;
      justify-content: center;
      padding: 20px 0;
    }
  }
  .order-history-row {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid var(--border);
    padding: 20px 30px;
    line-height: 36px;
    .order-history-image {
      width: 100px;
      display: flex;
      align-items: center;
      flex-shrink: 0;
      img {
        width: 100%;
      }
      @media only screen and (max-width: 499px) {
        display: none;
      }
    }
    .order-history-details {
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 65%;
    }

    .order-history-buttons {
      display: flex;
      flex-shrink: 0;
      flex-direction: column;
      justify-content: center;
      align-items: stretch;
    }
    &:first-child {
      border-top: 0;
    }

    .value {
      font-weight: 700;
    }
    .status {
      height: 36px;
      display: flex;
      align-items: center;
      span {
        display: flex !important;
        align-items: center;
        justify-content: center;
      }
    }
    .pending,
    .in-progress,
    .shipped,
    .completed,
    .cancelled,
    .return,
    .refund {
      span {
        display: block;
        text-align: center;
        font-size: 12px;
        line-height: 20px;
        font-weight: 700;
        text-transform: uppercase;
        padding: 2px 0;
        border-radius: 5px;
        width: 100px;
      }
    }
    .pending {
      span {
        color: var(--dark-grey);
        background-color: var(--yellow);
      }
    }
    .shipped {
      span {
        color: var(--white);
        background-color: var(--green);
      }
    }
    .completed {
      span {
        color: var(--white);
        background-color: var(--dark-grey);
      }
    }
    .cancelled {
      span {
        color: var(--dark-grey);
        background-color: var(--light-grey);
      }
    }
    .in-progress {
      span {
        color: var(--dark-grey);
        background-color: var(--green-highlight);
      }
    }
    .return {
      span {
        color: var(--white);
        background-color: var(--danger);
      }
    }
    .refund {
      span {
        color: var(--white);
        background-color: var(--mid-grey);
      }
    }
    @media only screen and (max-width: 767px) {
      & > div.order-history-details {
        width: auto;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        & > div {
          display: flex;
          flex-direction: row;
          .label {
            min-width: 60px;
            text-align: right;
            margin-right: 20px;
          }
          .value {
            min-width: 100px;
            text-align: left;
          }
        }
      }
    }
    @media only screen and (max-width: 599px) {
      padding: 20px;
    }
    @media only screen and (max-width: 499px) {
      flex-direction: column;
      align-items: center;
    }
  }
  .order {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
    & > div {
      width: 20%;
    }
  }
  .toast-error .toast-icon {
    background-color: var(--green) !important;
  }
  .upf50-logo {
    display: block;
    font-size: 45px;
    line-height: 100%;
    font-weight: 700;
    background-color: var(--dark-grey);
    color: var(--yellow);
    padding: 10px 15px;
    border-radius: 5px;
    width: fit-content;
    text-align: center;
    span {
      color: var(--green-highlight);
    }
    @media only screen and (max-width: 767px) {
      font-size: 28px;
      padding: 8px 12px;
    }
    @media only screen and (min-width: 768px) {
      font-size: 36px;
    }
    @media only screen and (min-width: 1150px) {
      font-size: 36px;
    }
    @media only screen and (min-width: 1366px) {
      font-size: 45px;
    }
  }
  .gallery-container {
    min-height: calc(var(--vh, 1vh) * 100);
    a {
      cursor: pointer;
    }
    button {
      cursor: pointer;
      padding: 0px;
      border: none;
      background-color: transparent;
      position: relative;
      border-radius: 5px;
      img {
        width: 100%;
        border-radius: 5px;
      }
      &:focus-visible {
        outline: 3px solid var(--orange-highlight);
        outline-offset: 3px;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(246, 139, 31, 0.15);
          pointer-events: none; /* allows clicks to pass through */
          z-index: 1;
        }
        img {
          filter: contrast(1.15);
        }
      }
    }
    img {
      display: inline-block;
      width: 100%;
    }
    @media only screen and (max-width: 767px) {
      column-count: 2;
      column-gap: 10px;
      button {
        margin-bottom: 10px;
      }
    }
    @media only screen and (min-width: 768px) {
      column-count: 3;
      column-gap: 15px;
      button {
        margin-bottom: 15px;
      }
    }
    @media only screen and (min-width: 1150px) {
      column-count: 4;
      column-gap: 20px;
      button {
        margin-bottom: 20px;
      }
    }
  }
  .size-badge {
    .size-type {
      display: inline-block !important;
      background-color: var(--yellow) !important;
      color: var(--dark-grey) !important;
      border-radius: 2px !important;
      padding: 0px 6px !important;
      font-weight: 700 !important;
      margin-left: 6px !important;
      margin-right: 0 !important;
      line-height: 150% !important;
      &.reg {
        background-color: var(--green) !important;
        color: var(--white) !important;
      }
    }
  }
`;

export const Announcements = styled.div`
  -webkit-font-smoothing: antialiased;
  background-color: #666666;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
  line-height: 24px;
  font-weight: 700;
  padding: 10px;
  text-align: center;
`;

export const NavigationBar = styled.div`
  background-color: #ffffff;
  color: var(--dark-grey);
  .logo:focus-visible {
    background-color: rgba(246, 139, 31, 0.15);
    box-shadow: 0 0 0 4px rgba(246, 139, 31, 0.15);
    display: block;
    .header-logo {
      .st2 {
        fill: var(--orange-highlight) !important;
      }
    }
  }
`;

export const NavigationItems = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
  & > a {
    display: flex;
    align-items: center;
  }
  .nav-menu {
    display: flex;
    justify-content: end;
    align-items: center;
    padding-right: 5px;
    a {
      padding-bottom: 0;
    }
    a.bag-link {
      margin-left: 10px;
      &:focus-visible {
        span {
          display: none;
        }
      }
    }
    a.account-link {
      margin: 0 10px;
      padding: 0;
      background-color: transparent;
    }
    a:focus-visible {
      border: none;
      outline: 2px solid var(--orange-highlight);
      background-color: rgba(246, 139, 31, 0.15);
      box-shadow: 0 0 0 10px rgba(246, 139, 31, 0.15);
      outline-offset: 5px;
      border-radius: 5px;
      color: #ffffff !important;
    }
    &.left {
      font-size: 16px;
    }
    @media only screen and (max-width: 1199px) {
      &.left,
      a.account-link {
        font-size: 14px;
      }
    }
    @media only screen and (max-width: 767px) {
      display: none;
    }
  }
  .get-started {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-size: 16px;
      font-weight: 700;
      margin-right: 20px;
      text-transform: uppercase;
    }
    @media only screen and (max-width: 1199px) {
      span {
        font-size: 14px;
      }
    }
    @media only screen and (max-width: 991px) {
      display: none;
    }
  }
`;

export const NavLinks = styled.div`
  a {
    margin: 0 10px;
    color: var(--dark-grey);
    font-weight: 700;
    text-transform: uppercase;
  }
`;

export const LogoRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 40px;
  .fa-solid {
    font-size: 24px;
    color: var(--green);
    margin-left: 20px;
  }
  a:last-child {
    margin-right: 0;
  }
`;

export const MenuButton = styled.div`
  display: none;
  cursor: pointer;
  text-align: right;
  i {
    color: var(--dark-grey);
    font-size: 24px;
    margin-left: 0 !important;
  }
  @media only screen and (max-width: 767px) {
    display: block;
  }
`;

export const LogoAndNav = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  svg {
    width: 150px;
    margin-right: 20px;
  }
  @media only screen and (max-width: 991px) {
    width: auto;
    svg {
      width: 150px;
    }
  }
`;

export const HomeHeroImage = styled.div`
  .banner-tablet,
  .banner-desktop,
  .banner-mobile {
    img {
      width: 100%;
    }
  }
  @media only screen and (max-width: 767px) {
    aspect-ratio: 767 / 464;
    .banner-mobile {
      display: block;
    }
    .banner-tablet,
    .banner-desktop {
      display: none;
    }
  }
  @media only screen and (min-width: 768px) {
    aspect-ratio: 991 / 400;
    .banner-tablet {
      display: block;
    }
    .banner-mobile,
    .banner-desktop {
      display: none;
    }
  }
  @media only screen and (min-width: 992px) {
    aspect-ratio: 1710 / 517;
    .banner-desktop {
      display: block;
    }
    .banner-tablet,
    .banner-mobile {
      display: none;
    }
  }
`;

export const HomeHeroRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: var(--white);
  padding-top: 20px;
  padding-bottom: 20px;
  & > div {
    margin: 20px 0 15px 0;
  }
  @media only screen and (min-width: 992px) {
    flex-direction: row;
    padding: 50px 0;
    margin: 0 auto;
    & > div {
      margin: 0 30px;
    }
  }
  @media only screen and (min-width: 1366px) {
    padding: 60px 0;
    margin: 0 auto;
    & > div {
      margin: 0 50px;
    }
  }
`;

export const HomeHeroText = styled.div`
  text-align: center;
  div.hero-text-top {
    display: flex;
    align-items: center;
    justify-content: center;
    span.upf50-logo {
      margin-right: 15px;
    }
    @media only screen and (max-width: 991px) {
      flex-direction: column;
      span.upf50-logo {
        margin-bottom: 12px;
        margin-right: 0;
      }
    }
    @media only screen and (max-width: 767px) {
      span.upf50-logo {
        margin-bottom: 8px;
      }
    }
  }
  span {
    &.upf50-text {
      display: block;
      font-size: 28px;
      line-height: 100%;
      font-family: "Figtree", sans-serif;
      color: var(--dark-grey);
      font-weight: 700;
      text-transform: uppercase;
    }
    &.hero-text-bottom {
      display: block;
      font-size: 28px;
      line-height: 100%;
      font-family: "Damion", sans-serif;
      color: var(--green);
      font-weight: 300;
      @media only screen and (max-width: 500px) {
        font-size: 26px;
      }
    }
    &.upf50-text {
      @media only screen and (min-width: 768px) {
        font-size: 36px;
      }
      @media only screen and (min-width: 1366px) {
        font-size: 45px;
      }
    }
    &.hero-text-bottom {
      @media only screen and (min-width: 500px) {
        font-size: 36px;
      }
      @media only screen and (min-width: 768px) {
        font-size: 45px;
      }
      @media only screen and (min-width: 991px) {
        font-size: 58px;
      }
      @media only screen and (min-width: 1366px) {
        font-size: 72px;
      }
    }
  }
`;

export const Story = styled.div`
  background-color: var(--dark-grey);
  padding: 30px;
  text-align: center;
  font-family: "Figtree", sans-serif;
  font-weight: 700;
  display: flex;
  align-items: center;
  h2 {
    font-style: italic;
    text-align: center;
    font-size: 18px;
    line-height: 30px;
    max-width: 1200px;
    margin: 0 auto;
    color: var(--mid-grey);
    span {
      color: var(--yellow);
      white-space: nowrap;
      span {
        color: var(--green-highlight);
      }
    }
  }
  img.logo {
    width: 100px;
    margin-right: 40px;
    display: block;
  }
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    h2 {
      max-width: 550px;
    }
    img.logo {
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
  @media only screen and (min-width: 768px) {
    h2 {
      font-size: 24px;
      line-height: 36px;
    }
    img.logo {
      width: 180px;
      margin-right: 20px;
    }
    padding: 50px;
  }
  @media only screen and (min-width: 992px) {
    padding: 50px 100px;
    margin-top: 0;
  }
  @media only screen and (min-width: 1150px) {
    padding: 50px 150px;
  }
  @media only screen and (min-width: 1366px) {
    h2 {
      font-size: 30px;
      line-height: 45px;
    }
    padding: 50px 16%;
  }
`;

export const Details = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 0;
  font-size: 20px;
  line-height: 30px;
  background-color: var(--white);
  color: var(--dark-grey);

  div.details-content {
    padding: 0 25px 0 50px;
    width: 50%;
    @media only screen and (max-width: 1365px) {
      padding: 0 15px 0 30px;
    }
    @media only screen and (min-width: 992px) and (max-width: 1129px) {
      width: 60%;
    }
  }

  div.details-graphic {
    padding: 0 50px 0 25px;
    width: 50%;
    display: flex;
    justify-content: space-between;
    @media only screen and (max-width: 1365px) {
      padding: 0 30px 0 15px;
    }
    .designed-for-outdoors {
      background-image: url(https://assets.greygullapparel.com/banners/designed-for-outdoors.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 90%;
      width: calc(50% - 15px);
      margin-right: 30px;
      border-radius: 5px;
      height: 450px;
    }
    a {
      margin: 30px auto;
    }
    .homepage-size-chart {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: calc(50% - 15px);
      background-color: var(--mid-grey);
      border-radius: 5px;
      .homepage-size-chart-columns {
        display: flex;
        .homepage-size-chart-column {
          width: 50%;
        }
      }
      p {
        font-size: 24px;
        text-align: center;
        font-weight: 700;
        margin-top: 20px;
        color: var(--dark-grey);
      }
      .size-heading {
        background-color: var(--dark-grey);
        text-align: center;
        padding: 10px;
        span {
          text-align: center;
          padding: 10px 0;
          font-weight: 700;
          &.regular {
            color: var(--green-highlight);
          }
          &.short {
            color: var(--yellow);
          }
        }
      }
      .size-values {
        padding: 0 10px;
        ul {
          margin: 0;
          padding: 0;
          margin-top: 10px;
          li {
            display: list-item;
            list-style: none;
            padding: 10px 0 0 0;
            text-align: center;
            color: var(--dark-grey);
            font-weight: 700;
            &:before {
              margin: 0;
            }
          }
        }
      }
      .short {
        padding-left: 25%;
      }
      .reg {
        padding-right: 25%;
      }
    }
    @media only screen and (min-width: 1366px), screen and (min-width: 768px) and (max-width: 991px) {
      .designed-for-outdoors {
        width: calc(60% - 15px);
      }
      .homepage-size-chart {
        width: calc(40% - 15px);
      }
    }
    @media only screen and (min-width: 992px) and (max-width: 1129px) {
      .designed-for-outdoors {
        background-size: 145%;
        background-position: top right;
      }
      .size-heading.reg {
        margin-top: 10px;
      }
    }

    @media only screen and (max-width: 767px) {
      font-size: 16px;
      .designed-for-outdoors {
        margin-right: 20px;
      }
      .designed-for-outdoors,
      .homepage-size-chart {
        width: calc(50% - 10px);
      }
    }

    @media only screen and (min-width: 1130px) {
      .designed-for-outdoors {
        height: 650px;
        background-position: 88%;
      }
    }

    @media only screen and (min-width: 1366px) {
      .designed-for-outdoors {
        height: 600px;
        background-position: 88%;
      }
    }

    @media only screen and (min-width: 992px) and (max-width: 1129px), screen and (max-width: 499px) {
      width: 40%;
      flex-direction: column;
      .designed-for-outdoors {
        width: 100%;
        margin-left: 0;
        margin-bottom: 30px;
        height: 300px;
        background-size: 145%;
        background-position: top right;
      }
      .homepage-size-chart {
        width: 100%;
        .homepage-size-chart-columns {
          flex-direction: column;
          .homepage-size-chart-column {
            width: 100%;
            .short,
            .reg {
              padding: 5px;
            }
            ul {
              display: flex;
              justify-content: center;
              margin: 0;
            }
            li {
              display: inline;
              padding: 0 10px;
            }
          }
        }
        a {
          margin: 10px auto 20px auto;
        }
      }
      @media only screen and (min-width: 1130px) {
        width: 50%;
        flex-direction: row;
      }
    }
    @media only screen and (max-width: 499px) {
      .designed-for-outdoors {
        height: 250px;
        background-size: 145%;
        background-position: 100% 20%;
      }
      .homepage-size-chart {
        font-size: 14px;
        .size-values {
          padding: 5px 0;
        }
        p {
          font-size: 18px;
        }
      }
    }
  }

  h3 {
    font-size: 50px;
    line-height: 60px;
    font-weight: 300;
    text-align: center;
    font-family: "Damion", sans-serif;
    color: var(--dark-grey);
    margin: 0 0 25px 0;
    border-bottom: 2px solid var(--green);
    padding-bottom: 20px;
    &.available-size-title {
      margin-top: 50px;
    }
  }

  @media only screen and (max-width: 991px) {
    flex-direction: column;
    div.details-content,
    div.details-graphic {
      width: 100%;
      padding: 0 30px;
    }
    div.details-content {
      padding-bottom: 20px;
      h3 {
        margin-bottom: 15px;
      }
      p {
        margin-bottom: 20px;
      }
    }
    padding: 30px 0;
  }
  @media only screen and (max-width: 767px) {
    div.details-content,
    div.details-graphic {
      padding: 0 20px;
    }
    div.details-content {
      h3 {
        margin-bottom: 20px;
        padding-bottom: 15px;
      }
      p {
        margin-bottom: 20px;
      }
    }
  }
  @media only screen and (max-width: 599px) {
    h3 {
      font-size: 40px;
      line-height: 50px;
      padding-bottom: 10px;
      margin-bottom: 15px;
    }
    p {
      margin-bottom: 15px;
    }
  }
  @media only screen and (max-width: 499px) {
    h3 {
      font-size: 30px;
      line-height: 40px;
    }
  }
  @media only screen and (min-width: 1366px) {
    div.details-content {
      width: 50%;
    }
    div.details-graphic {
      width: 50%;
    }
  }
`;

export const GraphicPosition = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 50px 0;
  font-size: 20px;
  line-height: 30px;
  background-color: var(--white);
  color: var(--dark-grey);

  div.details-content {
    padding: 0 50px 0 25px;
    width: 60%;
    p {
      font-size: 24px;
      line-height: 36px;
      font-style: italic;
      text-align: center;
      font-weight: 700;
      margin-bottom: 30px;
    }
    @media only screen and (max-width: 1365px) {
      padding: 0 30px 0 15px;
    }
  }

  div.details-graphic {
    padding: 0 25px 0 50px;
    width: 40%;
    img {
      width: calc(50% - 10px);
      border-radius: 5px;
      &:first-child {
        margin-right: 20px;
      }
    }
    @media only screen and (max-width: 1365px) {
      padding: 0 15px 0 30px;
    }
  }

  h3 {
    font-size: 50px;
    line-height: 60px;
    font-weight: 300;
    text-align: center;
    font-family: "Damion", sans-serif;
    color: var(--dark-grey);
    margin: 0 0 25px 0;
    border-bottom: 2px solid var(--green);
    padding-bottom: 20px;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    div.details-content,
    div.details-graphic {
      width: 100%;
      padding: 0 30px;
    }
    div.details-content {
      h3 {
        margin-bottom: 15px;
      }
      p {
        max-width: 700px;
        margin: 0 auto 20px;
      }
    }
    div.details-graphic {
      padding-bottom: 30px;
      img {
        object-fit: cover;
        height: 220px;
      }
    }
    padding: 30px 0;
  }

  @media only screen and (max-width: 767px) {
    div.details-content,
    div.details-graphic {
      padding-left: 20px;
      padding-right: 20px;
    }
    div.details-content {
      h3 {
        margin-bottom: 20px;
        padding-bottom: 15px;
      }
      p {
        font-size: 18px;
        line-height: 30px;
        margin-bottom: 20px;
        max-width: 550px;
      }
    }
  }
  @media only screen and (max-width: 599px) {
    div.details-content {
      h3 {
        font-size: 40px;
        line-height: 50px;
        padding-bottom: 10px;
        margin-bottom: 15px;
      }
      p {
        margin-bottom: 15px;
      }
    }
  }

  @media only screen and (max-width: 499px) {
    div.details-content {
      h3 {
        font-size: 30px;
        line-height: 40px;
      }
    }
  }

  @media only screen and (min-width: 992px) and (max-width: 1365px) {
    div.details-graphic {
      img {
        width: 100%;
        object-fit: cover;
        height: 220px;
        &:first-child {
          margin-bottom: 20px;
        }
      }
    }
  }
  @media only screen and (min-width: 1366px) {
    div.details-content {
      width: 50%;
    }
    div.details-graphic {
      width: 50%;
      img {
        object-fit: cover;
        height: 380px;
      }
    }
  }
`;

export const UPF50 = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 50px;
  font-size: 20px;
  line-height: 30px;
  background-color: var(--green);
  color: var(--white);

  div.UPF50-infographic {
    background-color: var(--white);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: stretch;
    border-radius: 5px;
    margin-right: 25px;
    padding: 30px;
    width: 50%;
    span.upf50-logo {
      display: block;
      margin: 0 auto;
    }
    span.upf50-title {
      font-family: "Figtree", sans-serif;
      display: block;
      font-size: 30px;
      line-height: 40px;
      font-style: italic;
      font-weight: 700;
      color: var(--dark-grey);
      margin: 10px auto;
      text-align: center;
      max-width: 500px;
      @media only screen and (max-width: 767px) {
        font-size: 24px;
        line-height: 30px;
      }
      @media only screen and (max-width: 499px) {
        font-size: 18px;
        line-height: 24px;
        max-width: 300px;
      }
      @media only screen and (min-width: 500px) and (max-width: 767px) {
        max-width: 400px;
      }
      @media only screen and (min-width: 992px) and (max-width: 1199px) {
        font-size: 24px;
        line-height: 32px;
        max-width: 400px;
      }
    }

    div.upf-table {
      border-top: 2px solid var(--green);
      color: var(--dark-grey);
      margin-top: 20px;
      div.upf-row {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 10px 0;
        &.upf-table-header {
          font-family: "Figtree", sans-serif;
          font-weight: 700;
        }
        &.poor {
          background-color: var(--dark-grey);
          color: var(--white);
          margin-bottom: 5px;
        }
        &.good {
          background-color: #999;
          color: var(--white);
          margin-bottom: 5px;
        }
        &.better {
          background-color: var(--mid-grey);
          color: var(--dark-grey);
          margin-bottom: 5px;
        }
        &.best {
          background-color: var(--yellow);
          font-weight: 700;
        }
      }
      div.upf-column {
        width: 50%;
        text-align: center;
      }
      @media only screen and (max-width: 1199px) {
        div.upf-column {
          font-size: 18px;
          line-height: 24px;
        }
      }
      @media only screen and (max-width: 499px) {
        div.upf-column {
          font-size: 14px;
          line-height: 20px;
        }
        margin-top: 10px;
      }
    }
    @media only screen and (max-width: 991px) {
      width: 100%;
      margin-right: 0;
    }
    @media only screen and (max-width: 599px) {
      padding: 20px;
    }
    @media only screen and (min-width: 1200px) {
      padding: 40px;
    }
  }

  div.UPF50-content {
    margin-left: 25px;
    width: 50%;
    font-weight: 700;
    h3 {
      margin-top: 0;
      font-size: 24px;
      line-height: 30px;
      font-family: "Figtree", sans-serif;
      font-weight: 700;
      color: var(--white);
      text-align: center;
      &.cotton {
        margin-top: 40px;
      }
    }
    p {
      background-color: var(--green-highlight);
      color: var(--white);
      padding: 30px;
      margin: 0;
      border-radius: 5px;
      span {
        color: var(--yellow);
      }
    }
    @media only screen and (max-width: 991px) {
      width: 100%;
      margin: 30px 0 0 0;
      h3 {
        &.cotton {
          margin-top: 30px;
        }
      }
    }
    @media only screen and (max-width: 599px) {
      h3 {
        font-size: 20px;
        line-height: 26px;
      }
      p {
        padding: 20px;
      }
    }
    @media only screen and (min-width: 992px) and (max-width: 1365px) {
      font-size: 18px;
      line-height: 24px;
    }
    @media only screen and (min-width: 1200px) {
      h3 {
        font-size: 30px;
        line-height: 40px;
      }
      p {
        padding: 40px;
      }
    }
  }

  @media only screen and (min-width: 992px) and (max-width: 1365px) {
    padding: 50px 30px;
  }

  @media only screen and (max-width: 991px) {
    flex-direction: column;
    padding: 30px;
  }
  @media only screen and (max-width: 767px) {
    padding: 30px 20px;
  }
`;

export const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--white);
  background-color: var(--green);
  border-radius: 100px;
  padding: 8px 20px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  text-transform: uppercase;
  border: 0;
  &.stacked-button {
    background-color: var(--white);
    color: var(--dark-grey);
    border: 1px solid var(--border);
    border-radius: 5px;
    margin-bottom: 15px;
    padding: 15px;
    font-size: 14px;
    width: 100%;
    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      background-color: var(--green);
      border: 1px solid var(--green);
      color: var(--white);
    }
  }
  &.green {
    background-color: var(--green);
    color: var(--white);
  }
  &.grey {
    background-color: var(--dark-grey);
  }
  &.lightgrey {
    background-color: var(--mid-grey);
  }
  &.yellow {
    background-color: var(--yellow);
    color: var(--dark-grey);
    &:focus-visible {
      outline-offset: 3px !important;
    }
  }
  &.green-highlight {
    background-color: var(--green-highlight);
    color: var(--dark-grey) !important;
  }
  &.clear {
    background-color: transparent;
    color: var(--dark-grey) !important;
    border: 1px solid var(--dark-grey);
    &:focus-visible {
      border-color: var(--orange-highlight) !important;
    }
  }
  .fa-cart-shopping {
    margin-right: 6px;
  }
  i {
    font-size: 16px;
  }
  &.autoWidth {
    display: inline-block;
  }
  &.white {
    background-color: var(--white);
    color: var(--dark-grey) !important;
    &:focus-visible {
      outline: 2px solid var(--white) !important;
      outline-offset: 3px !important;
    }
  }
  &.small {
    font-size: 12px;
    padding: 2px 15px;
    line-height: 24px;
  }
  &.large {
    font-size: 16px;
  }
  &.order-history-link {
    padding: 2px 15px;
    margin: 5px 0;
    line-height: 22px;
    min-width: 150px;
  }
  &.textWithIcon {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: 0 0 0 auto !important;
    color: var(--dark-grey);
    font-weight: 700;
    text-transform: uppercase;
    font-size: 13px;
    border: 0;
    background-color: transparent !important;
    letter-spacing: 0;
    padding: 0;
    i {
      margin-right: 6px;
    }
    &:focus-visible {
      outline: 2px solid var(--orange-highlight);
      outline-offset: 5px;
      border-radius: 5px;
      background-color: transparent !important;
      color: var(--dark-grey) !important;
    }
  }
  &.add-to-cart-button {
    justify-self: end;
    margin-top: 20px;
  }
  &.on-dark-bg {
    &:focus-visible {
      outline-color: var(--white) !important;
    }
  }
  &:focus-visible {
    background-color: var(--orange-highlight) !important;
    color: var(--white) !important;
    outline: 2px solid var(--dark-grey);
    outline-offset: 2px;
    box-shadow: none;
  }
`;

export const ButtonLink = styled(Link)`
  text-decoration: none;
  display: block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--white) !important;
  background-color: var(--green);
  padding: 8px 20px;
  border-radius: 100px;
  margin-top: 5px;
  margin-bottom: 5px;
  cursor: pointer;
  text-align: center;
  text-transform: uppercase;
  &.grey {
    background-color: var(--dark-grey);
  }
  &.lightgrey {
    background-color: var(--mid-grey);
  }
  &.yellow {
    background-color: var(--yellow);
    color: var(--dark-grey) !important;
    &:focus-visible {
      outline-color: var(--white);
      outline-offset: 3px;
    }
  }
  &.green-highlight {
    background-color: var(--green-highlight);
    color: var(--dark-grey) !important;
  }
  &.clear {
    background-color: transparent;
    color: var(--dark-grey) !important;
    border: 1px solid var(--dark-grey);
    &:focus-visible {
      border-color: var(--orange-highlight) !important;
    }
  }
  &.white {
    background-color: var(--white);
    color: var(--dark-grey) !important;
  }
  &.autoWidth {
    display: inline-block;
  }
  &.small {
    font-size: 12px;
    padding: 2px 15px;
    line-height: 24px;
  }
  &.large {
    font-size: 16px;
  }
  &.autoFitCenter {
    width: fit-content;
    margin: 0 auto;
  }
  &.order-history-link {
    padding: 2px 15px;
    margin: 5px 0;
    line-height: 22px;
    min-width: 150px;
  }
  &:focus-visible {
    background-color: var(--orange-highlight) !important;
    color: var(--white) !important;
    outline: 2px solid var(--dark-grey);
    outline-offset: 2px;
    box-shadow: none;
  }
`;

export const ActionLink = styled.div`
  text-decoration: none;
  color: var(--dark-grey);
  cursor: pointer;
`;

export const CartIcon = styled(Link)`
  position: relative;
  span {
    font-size: 12px;
    font-weight: 700;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -5px;
    right: -10px;
    background-color: var(--green);
    border-radius: 100px;
    color: var(--white);
    width: 20px;
    height: 20px;
  }
`;

export const HeaderTemplate = styled(Container)`
  .header {
    padding: 40px 30px 10px;
    min-height: 65px;
    .title {
      color: var(--dark-grey);
      display: flex;
      height: 50px;
      align-items: center;
      h1 {
        font-family: "Figtree", sans-serif;
        font-weight: 700;
        font-size: 22px;
        margin-bottom: 0;
        padding-bottom: 0;
        @media only screen and (max-width: 767px) {
          font-size: 18px;
        }
      }
    }
    .breadcrumb {
      padding: 20px 0 0;
      a:focus-visible {
        outline: 2px solid var(--dark-grey);
        outline-offset: 2px;
      }
    }
    .content {
      display: flex;
      justify-content: start;
      align-items: center;
      padding: 20px 0;
      color: var(--dark-grey);
      h1 {
        padding: 0;
        margin: 0;
        margin-right: 50px;
      }
    }
    &.flex-header {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .title,
      .breadcrumb {
        padding: 0;
        margin: 0;
      }
      h1 {
        margin-right: 15px;
      }
      &.with-size-key {
        background-color: var(--dark-grey);
        color: var(--white);
        margin-top: 30px;
        margin-bottom: 20px;
        border-radius: 5px;
        padding-top: 10px;
        h1 {
          color: var(--white);
        }
        .size-key {
          flex-grow: 1;
          text-align: right;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          & > div {
            font-weight: bold;
            span {
              display: inline-block;
              background-color: var(--yellow);
              color: var(--dark-grey);
              border-radius: 2px;
              padding: 0px 6px;
              font-weight: 700;
              margin-left: 6px;
              line-height: 150%;
              &.reg {
                background-color: var(--green);
                color: var(--white);
              }
            }
            &:first-child {
              margin-right: 20px;
            }
          }
          @media only screen and (max-width: 767px) {
            font-size: 12px;
            & > div:first-child {
              margin-right: 10px;
            }
          }
        }
      }
    }
    @media only screen and (max-width: 991px) {
      padding: 40px 20px 10px;
    }
  }
  &.narrow {
    max-width: 1200px;
  }
`;

export const PageTemplate = styled(Container)`
  &.order-lookup {
    padding: 0 20px;
    max-width: 1920px;
    width: 100%;
    margin: 0 auto;
    @media only screen and (min-width: 768px) {
      padding: 0 30px;
    }
    @media only screen and (min-width: 1366px) {
      padding: 0 40px;
    }
  }
  .columns {
    display: flex;
    justify-content: space-between;
    .left-column,
    .right-column {
      width: 50%;
      .size-chart-border {
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        overflow: hidden;
      }
      .size-chart-bottom {
        background-color: var(--white);
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        border: 1px solid var(--border);
        border-top: 0;
        text-align: center;
        padding: 20px;
        font-style: italic;
        font-size: 14px;
      }
    }
    .left-column {
      padding-right: 30px;
      .shirt-size-graphic {
        background-color: var(--white);
        border: 1px solid var(--border);
        min-height: 100%;
        margin-bottom: 20px;
        padding: 10px 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        img {
          width: 100%;
          max-width: 500px;
        }
      }
    }
    &.success {
      .left-column {
        width: 60%;
      }
      .right-column {
        background-color: var(--mid-grey);
        border-radius: 5px;
        color: var(--white);
        padding: 30px;
        width: 40%;
      }
    }
    &.checkout {
      input {
        background-color: var(--off-white);
      }
      .left-column {
        width: 60%;
      }
      .right-column {
        width: 40%;
        @media only screen and (max-width: 991px) {
          margin-top: 30px;
        }
      }
    }
    @media only screen and (max-width: 991px) {
      flex-direction: column;
      &.success {
        flex-direction: column-reverse;
        .right-column {
          margin-bottom: 30px;
          padding: 20px;
        }
      }
      .left-column,
      .right-column {
        width: 100% !important;
        padding-right: 0;
      }
    }
  }
  .start-return {
    background-color: var(--white);
    overflow: hidden;
    margin-bottom: 30px;
    h2 {
      padding: 10px 40px;
      margin-top: 10px;
    }
    @media only screen and (min-width: 500px) {
      border-radius: 5px;
    }
  }
  .start-return-exchange-row {
    background-color: var(--white);
    overflow: hidden;
    line-height: 36px;
    margin-bottom: 30px;
    .return-exchange-product {
      .form-check {
        margin-bottom: 0;
        margin-right: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
      }
      input[type="checkbox"] {
        border-color: var(--green) !important;
        width: 1.5em !important;
        height: 1.5em !important;
      }
      input:checked {
        background-color: var(--green) !important;
        border-color: var(--green) !important;
      }
      padding: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .return-exchange-details {
        display: flex;
        align-items: center;
        justify-content: space-around;
        width: 70%;
        & > div {
          display: flex;
          flex-direction: column;
          text-align: center;
          @media only screen and (min-width: 768px) {
            flex-direction: row;
            span {
              margin-right: 20px;
            }
          }
        }
        @media only screen and (max-width: 767px) {
          width: 50%;
        }
      }
      .product-image {
        min-width: 150px;
        min-height: 150px;
        img {
          max-width: 130px;
          max-height: 130px;
        }
      }
      @media only screen and (max-width: 991px) {
        padding: 20px;
      }

      @media only screen and (max-width: 767px) {
        .product-image {
          min-width: 120px;
          min-height: 120px;
          img {
            max-width: 100px;
            max-height: 100px;
          }
        }
      }

      @media only screen and (max-width: 499px) {
        padding: 15px;
        .product-image {
          min-width: 100px;
          min-height: 100px;
          img {
            max-width: 80px;
            max-height: 80px;
          }
        }
      }
    }
    .return-exchange-dropdowns {
      &.hide {
        display: none;
      }
      &.error {
        background-color: var(--danger);
      }
      background-color: var(--mid-grey);
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 30px;
      .refund-amount {
        color: var(--white);
        line-height: 18px;
        font-weight: 700;
        span {
          margin-left: 20px;
        }
      }
      .left-return-options {
        display: flex;
      }
      .right-return-options {
        flex-grow: 1;
        text-align: right;
      }
      @media only screen and (max-width: 991px) {
        padding: 15px 20px;
        & > div {
          width: 250px;
          .exchange-dropdowns {
            flex-direction: column;
          }
        }
        .left-return-options {
          flex-direction: column;
          .return-type {
            margin-bottom: 15px;
          }
        }
        .right-return-options {
          #sizeExchange {
            margin-bottom: 15px;
          }
        }
      }
      @media only screen and (max-width: 767px) {
        flex-direction: column;
        padding: 25px;
        .refund-amount {
          text-align: center;
        }
        & > div {
          width: 250px;
          & select#sizeExchange,
          & select#positionExchange,
          & .refund-amount {
            margin-top: 15px;
          }
        }
      }
      @media only screen and (min-width: 992px) {
        .return-type {
          margin-right: 20px;
        }
      }
    }
    @media only screen and (max-width: 767px) {
      margin-bottom: 20px;
    }
    @media only screen and (min-width: 500px) {
      border-radius: 5px;
    }
    @media only screen and (min-width: 768px) {
      .exchange-dropdowns {
        display: flex;
        place-self: flex-end;
        select {
          width: auto;
        }
      }
    }
    @media only screen and (min-width: 992px) {
      .exchange-dropdowns {
        select {
          &#sizeExchange {
            margin-right: 20px;
          }
        }
      }
    }
  }
  &.narrow {
    max-width: 1200px;
  }
  .order-search {
    display: flex;
    margin-top: 0;
    margin-bottom: 40px;
    justify-content: space-between;
    align-items: center;
    background-color: var(--white);
    border-radius: 5px;
    padding: 30px;
    .form-group {
      display: flex;
      align-items: center;
      flex-grow: 1;
      input {
        margin-bottom: 0;
        margin-right: 30px;
        flex-grow: 1;
        font-weight: 300;
        background-color: var(--off-white);
      }
    }
    button {
      justify-self: end;
      padding: 4px 40px;
      margin-left: 20px;
    }
    @media only screen and (max-width: 767px) {
      flex-direction: column;
      padding: 30px 20px;
      .form-group {
        width: 100%;
        margin-bottom: 20px;
      }
      button {
        margin-left: 0;
      }
      input {
        margin-right: 0 !important;
      }
    }
  }
  .order-lookup-result {
    background-color: var(--white);
    color: var(--dark-grey);
    overflow: hidden;
    .order-history-row {
      border-bottom: 1px solid var(--border);
      background-color: var(--off-white);
    }
    .order-footer {
      border-top: 1px solid var(--border);
      background-color: var(--off-white);
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price-details {
        display: flex;
        .order-footer-labels {
          display: flex;
          flex-direction: column;
          margin-right: 20px;
          text-align: right;
        }
        .order-footer-values {
          display: flex;
          flex-direction: column;
          font-weight: 700;
        }
      }
    }
    @media only screen and (min-width: 500px) {
      border-radius: 5px;
    }
  }
  .return-confirmation-title {
    background-color: var(--green);
    border-radius: 5px;
    color: var(--white);
    margin-bottom: 20px;
    h2 {
      color: var(--white);
      padding-bottom: 0;
      margin-bottom: 10px;
    }
    p {
      margin-bottom: 0;
    }
    @media only screen and (max-width: 767px) {
      font-size: 18px;
    }
  }
  .centered-icon {
    width: 50px;
    margin: 20px auto 10px auto;
    display: block;
  }
  .content-page {
    background-color: var(--white);
    border-radius: 5px;
    padding: 30px;
    &.grey {
      background-color: var(--dark-grey);
    }
    &.user-verification-message {
      text-align: center;
      h2 {
        margin-bottom: 5px;
        text-transform: capitalize;
        &.success {
          color: var(--green);
        }
        &.failed {
          color: var(--danger);
        }
      }
    }
    @media only screen and (max-width: 991px) {
      padding: 25px 20px 20px;
    }
  }
  .content-page-form {
    input,
    textarea,
    label {
      padding: 20px 30px;
      @media only screen and (max-width: 991px) {
        padding: 20px;
      }
    }
  }
  &.policy {
    h2 {
      font-size: 20px;
      margin-top: 40px;
      font-weight: 700;
    }
    h3 {
      font-size: 20px;
      font-weight: 700;
    }
    a {
      color: var(--green);
      text-decoration: underline;
    }
    table {
      margin-bottom: 40px;
      @media only screen and (max-width: 767px) {
        font-size: 14px;
        line-height: 20px;
      }
      @media only screen and (max-width: 450px) {
        font-size: 12px;
        line-height: 18px;
      }
    }
    th {
      border-width: 1px;
    }
    td {
      border-width: 1px;
      vertical-align: top;
    }
    p.table-of-contents {
      line-height: 30px;
    }
    li {
      margin: 10px 0;
    }
  }
  &.size-guide-modal {
    padding: 30px;
    @media only screen and (max-width: 991px) {
      padding: 20px;
    }
  }
  .size-chart {
    background-color: var(--white);
    th,
    td {
      text-align: center;
      padding: 10px;
      &.size-type-label {
        color: var(--white);
        font-weight: 700;
        background-color: var(--dark-grey);
        border: 1px solid var(--dark-grey);
        span {
          display: inline-block;
          background-color: var(--yellow);
          color: var(--dark-grey);
          border-radius: 2px;
          padding: 0px 6px;
          font-weight: 700;
          margin-left: 5px;
          line-height: 150%;
          &.reg {
            background-color: var(--green);
            color: var(--white);
          }
        }
      }
    }
    th {
      background-color: var(--green);
      border: 1px solid var(--green);
      color: var(--white);
    }
    tr {
      border-left: 1px solid var(--border);
      border-right: 1px solid var(--border);
      td.size-label,
      strong {
        font-weight: 700;
      }
      &:nth-child(even) {
        background-color: var(--off-white);
        border-top: 1px solid var(--border);
        border-bottom: 1px solid var(--border);
      }
      &:last-child {
        border-bottom: 1px solid var(--border) !important;
      }
      &.empty-row {
        background-color: transparent !important;
        border-top: 0 !important;
        border-bottom: 0;
      }
      &.bottom-border {
        border-bottom: 1px solid var(--border);
      }
    }
    @media only screen and (max-width: 767px) {
      font-size: 14px;
    }
  }
  &.large {
    h2 {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 50px;
      font-weight: 300;
      line-height: 60px;
      font-family: "Damion", sans-serif;
      color: var(--dark-grey);
      text-align: center;
      padding: 0;
      margin: 40px 0 20px 0;
    }
    @media only screen and (max-width: 991px) {
      h2 {
        margin: 30px 0 20px 0;
      }
    }
    @media only screen and (max-width: 599px) {
      h2 {
        font-size: 40px;
        line-height: 50px;
      }
    }
    @media only screen and (max-width: 499px) {
      h2 {
        font-size: 30px;
        line-height: 40px;
      }
    }
  }
  .designs-container {
    display: grid;
    min-height: calc(var(--vh, 1vh) * 100);
    button {
      cursor: pointer;
      padding: 0px;
      border: none;
      background-color: transparent;
      position: relative;
      img {
        width: 100%;
        padding: 5px;
      }
      &:focus-visible {
        outline: 3px solid var(--orange-highlight);
        outline-offset: -3px;
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(246, 139, 31, 0.15);
          pointer-events: none; /* allows clicks to pass through */
          z-index: 1;
        }
        img {
          filter: contrast(1.15);
        }
      }
    }
    @media only screen and (max-width: 767px) {
      grid-template-columns: 1fr 1fr;
    }
    @media only screen and (min-width: 768px) {
      grid-template-columns: 1fr 1fr 1fr;
    }
    @media only screen and (min-width: 992px) {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
    @media only screen and (min-width: 1200px) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    }
    @media only screen and (min-width: 1365px) {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    }

    @media only screen and (max-width: 599px) {
      h2 {
        font-size: 40px;
        line-height: 50px;
      }
    }
    @media only screen and (max-width: 499px) {
      h2 {
        font-size: 30px;
        line-height: 40px;
      }
    }
  }
  .loading-screen {
    display: none;
    background-color: rgba(83, 85, 90, 0.75);
    position: fixed;
    height: calc(var(--vh, 1vh) * 100);
    width: 100vw;
    top: 0;
    left: 0;
  }

  .loadingImages {
    aspect-ratio: 1/1;
    gap: 0;
    img {
      display: none;
    }
    column-gap: 0;
    display: flex;
    justify-content: center;
    .loading-screen {
      display: block;
      .loading-bar {
        position: absolute;
        top: calc(50vh - 10px);
        border-radius: 5px;
        left: 25vw;
        width: 50vw;
        height: 20px;
        background-color: var(--mid-grey);
        overflow: hidden;
        .loading-bar-progress {
          background-color: var(--yellow);
          height: 20px;
        }
      }
    }
  }
`;

export const AccountTemplate = styled(Container)`
  max-width: 1200px;
  .account-info {
    background-color: var(--dark-grey);
    border-radius: 5px;
    color: var(--white) !important;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--dark-grey);
    padding: 20px 30px;
    margin-bottom: 20px;
    .name {
      font-size: 18px;
      font-weight: 700;
    }
    .logout {
      margin-top: 12px;
    }
    .account-buttons {
      button {
        width: 100%;
        &:focus-visible {
          outline-offset: 3px;
        }
      }
    }
    @media only screen and (max-width: 767px) {
      flex-direction: column;
      .name,
      .email {
        text-align: center;
      }
      .account-buttons {
        margin-top: 10px;
        min-width: 50%;
      }
    }
    @media only screen and (max-width: 499px) {
      .account-buttons {
        min-width: 75%;
      }
    }
  }
  .order-history {
    background-color: var(--white);
    border-radius: 5px;
    overflow: hidden;
    & > div:nth-child(even) {
      background-color: var(--off-white);
    }
  }
  .order-history-buttons {
    @media only screen and (max-width: 499px) {
      margin: 20px 0 10px 0;
      min-width: 75%;
    }
  }
    @media only screen and (min-width: 500px) {
      border-radius: 5px;
    }
  }
`;

export const CartTemplate = styled(Container)`
  max-width: 1200px;
  .cart-bottom-boxes {
    .size-guide {
      background-color: var(--green);
      span {
        display: block;
        margin-bottom: 15px;
      }
    }
    .cart-checkout-box {
      background-color: var(--dark-grey);
      .cart-total {
        margin-bottom: 15px;
        span {
          font-weight: 700;
          margin-left: 20px;
        }
      }
    }
    .size-guide,
    .cart-checkout-box {
      color: var(--white);
      border-radius: 5px;
      padding: 30px;
      margin-top: 20px;
      font-size: 18px;
      text-align: center;
      @media only screen and (max-width: 499px) {
        font-size: 16px;
        strong {
          display: block;
        }
      }
    }
    @media only screen and (min-width: 500px) {
      .size-guide-button,
      .checkout-button {
        width: 50%;
        margin: 0 auto;
      }
    }
    @media only screen and (min-width: 992px) {
      display: flex;
      justify-content: space-between;
      & > div {
        &:first-child {
          width: 65%;
          margin-right: 10px;
        }
        &:last-child {
          width: 35%;
          margin-left: 10px;
        }
      }
      .size-guide-button {
        width: fit-content;
        margin: 0 auto;
        min-width: 200px;
      }
      .checkout-button {
        width: fit-content;
        margin: 0 auto;
        min-width: 200px;
      }
    }
  }
`;

export const LoaderStyles = styled.div`
  overflow: hidden;
  touch-action: none; /* Prevents swipe gestures on mobile */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  background-color: var(--dark-grey);
  z-index: 1000;
  font-size: 30px;
  .gg-logo {
    width: 80px;
  }
`;

export const CustomerProduct = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--border);
  padding: 20px 30px;
  &:last-child {
    border-bottom: 0;
  }
  div {
    text-align: center;
    &.product-image {
      width: 20%;
      aspect-ratio: 1 / 1;
      img {
        width: 90%;
      }
    }
    &.product-price {
      width: 20%;
    }
    &.product-size {
      width: 20%;
    }
    &.product-position {
      width: 25%;
    }
    &.product-quantity {
      width: 15%;
    }
  }
  img {
    border-radius: 5px;
  }
  @media only screen and (max-width: 767px) {
    div {
      font-size: 14px;
    }
  }
  @media only screen and (max-width: 991px) {
    padding: 20px;
  }
`;

export const CustomerShipping = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: center;
  padding: 30px;
  background-color: var(--white);
  & > div {
    width: 50%;
    padding: 20px;
    background-color: var(--mid-grey);
    color: var(--white);
    border-radius: 5px;
    strong {
      color: var(--dark-grey);
    }
    &:first-child {
      margin-right: 15px;
    }
    &:last-child {
      margin-left: 15px;
    }
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    padding: 20px;
    & > div {
      width: 100%;
      &:first-child {
        margin-right: 0;
        margin-bottom: 20px;
      }
      &:last-child {
        margin-left: 0;
      }
    }
  }
`;

export const Empty = styled.div`
  width: 50%;
  margin: 20px auto;
  text-align: center;
`;

export const NoOrdersYet = styled(Empty)`
  height: 242px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  h1 {
    margin-bottom: 20px;
  }
`;

export const EmptyCart = styled(NoOrdersYet)`
  background-color: var(--white);
  border-radius: 5px;
  margin: 65px 20px 0 20px;
  width: calc(100% - 40px);
  box-sizing: border-box;
  @media only screen and (min-width: 540px) {
    margin: 65px auto 0 auto;
    width: 500px;
  }
`;

export const VerifyEmail = styled(Empty)`
  width: 100%;
  .logout {
    display: inline-block;
  }
`;

export const CheckoutStyles = styled.div`
  #payment-message {
    color: var(--danger);
    font-size: 16px;
    line-height: 20px;
    padding: 8px 20px;
    border-radius: 5px;
  }

  .placeOrderButtonWithMessage {
    display: flex;
    justify-content: space-between;
    align-items: center;
    button {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      &:focus-visible {
        outline: 2px solid var(--dark-grey);
        outline-offset: 2px;
      }
    }
    span.loading {
      visibility: hidden;
    }
    i {
      position: absolute;
      color: var(--white);
      font-size: 24px;
    }
  }
  /* Buttons and links */
  button {
    background: var(--green);
    font-family: "Figtree", sans-serif;
    color: var(--white);
    border-radius: 100px;
    border: 0;
    padding: 8px 20px;
    font-size: 12px;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 700;
    cursor: pointer;
    display: block;
    width: auto;
    flex-shrink: 0;
    margin-left: auto;
  }

  button:disabled {
    opacity: 0.5;
    cursor: default;
  }

  /* spinner/processing state, errors */
  .spinner,
  .spinner:before,
  .spinner:after {
    border-radius: 50%;
  }

  .spinner {
    color: var(--white);
    font-size: 22px;
    text-indent: -99999px;
    margin: 0px auto;
    position: relative;
    width: 20px;
    height: 20px;
    box-shadow: inset 0 0 0 2px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }

  .spinner:before,
  .spinner:after {
    position: absolute;
    content: "";
  }

  .spinner:before {
    width: 10.4px;
    height: 20.4px;
    background: var(--green);
    border-radius: 20.4px 0 0 20.4px;
    top: -0.2px;
    left: -0.2px;
    -webkit-transform-origin: 10.4px 10.2px;
    transform-origin: 10.4px 10.2px;
    -webkit-animation: loading 2s infinite ease 1.5s;
    animation: loading 2s infinite ease 1.5s;
  }

  .spinner:after {
    width: 10.4px;
    height: 10.2px;
    background: var(--green);
    border-radius: 0 10.2px 10.2px 0;
    top: -0.1px;
    left: 10.2px;
    -webkit-transform-origin: 0px 10.2px;
    transform-origin: 0px 10.2px;
    -webkit-animation: loading 2s infinite ease;
    animation: loading 2s infinite ease;
  }

  @keyframes loading {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;

export const FooterStyles = styled.div`
  background-color: var(--white);
  font-size: 13px;

  div.top-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > div {
      @media only screen and (min-width: 992px) {
        width: 33.333%;
      }
      &.policies {
        text-align: right;
      }
    }
    .questions {
      display: flex;
      justify-content: center;
      align-items: center;
      span {
        margin: 0 10px;
      }
      @media only screen and (max-width: 991px) {
        order: 3;
      }
      @media only screen and (max-width: 1099px) {
        flex-direction: column;
      }
    }
  }

  div.bottom-bar {
    display: flex;
    // justify-content: space-between;
    justify-content: center;
    background-color: var(--dark-grey);
    color: var(--mid-grey);
    align-items: center;
    img {
      display: block;
      margin: 0 5px;
    }
    div {
      display: flex;
    }
    div.copyright {
      font-weight: 700;
      align-items: center;
      img {
        width: 50px;
      }
    }
    div.social {
      align-items: center;
      a {
        color: var(--mid-grey);
        margin: 0 6px;
        font-size: 24px;
      }
      span {
        margin-right: 10px;
      }
    }
    div.copyright > div {
      margin: 0 6px;
    }
    @media only screen and (max-width: 991px) {
      div.copyright {
        padding: 8px;
      }
      div.social {
        flex-direction: column;
        padding: 8px;
        span {
          display: none;
        }
      }
      img {
        margin: 0;
        margin-bottom: 10px;
      }
    }

    @media only screen and (max-width: 767px) {
      flex-direction: column;
      div.copyright {
        flex-direction: column;
        align-items: center;
      }
    }
  }

  span {
    font-weight: 700;
  }

  a {
    margin: 0 8px;
    &:focus-visible {
      border: none;
      background-color: rgba(246, 139, 31, 0.15);
      box-shadow: 0 0 0 10px rgba(246, 139, 31, 0.15);
      outline: 2px solid var(--orange);
      outline-offset: 5px;
      border-radius: 5px;
    }
  }

  div.top-bar,
  div.bottom-bar {
    padding: 20px;
  }

  @media only screen and (max-width: 991px) {
    div.top-bar,
    div.bottom-bar {
      flex-direction: column;
    }
    div.top-bar {
      & > div {
        padding: 8px 0;
      }
    }
  }
  @media only screen and (min-width: 768px) {
    div.top-bar,
    div.bottom-bar {
      padding: 20px 30px;
    }
  }
  @media only screen and (min-width: 1366px) {
    div.top-bar,
    div.bottom-bar {
      padding: 30px 40px;
    }
  }
`;

export const Refund = styled.div`
  display: flex;
  overflow: hidden;
  justify-content: space-between;
  align-items: stretch;
  background-color: var(--white);
  color: var(--dark-grey);
  text-align: center;
  font-weight: 700;
  &:first-child {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
  &:last-child {
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    .return-products,
    .return-product,
    .return-details {
      border-bottom: 0;
    }
  }
  &:nth-child(even) {
    background-color: var(--off-white);
    .return-details {
      background-color: #939ea8 !important;
    }
  }
  .return-details {
    background-color: var(--mid-grey);
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-weight: 300;
    align-self: stretch;
    color: var(--white);
    padding: 20px 30px;
    min-width: 200px;
    border-bottom: 1px solid #858f98;
    & > div {
      font-size: 14px;
      line-height: 24px;
      padding: 10px 0;
      span {
        font-weight: 700;
        font-size: 18px;
      }
    }
    @media only screen and (max-width: 991px) {
      border-right: 0;
      border-bottom: 0 !important;
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: space-around;
      & > div {
        font-size: 12px;
        font-weight: 700;
        span {
          font-size: 16px;
        }
        &.return-label {
          width: 100%;
          & > div {
            width: fit-content;
            margin: 0 auto;
          }
        }
      }
    }
  }
  .return-products {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    border-bottom: 1px solid var(--border);
    padding: 10px 0;
  }
  .return-product {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 20px;
    margin-bottom: 0;
    .products-view-image {
      margin-right: 20px;
      min-width: 130px;
      min-height: 130px;
      img {
        max-width: 110px;
        max-height: 110px;
      }
    }
    .products-view-details {
      font-weight: 300;
      width: 100%;
      & > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        & > div {
          position: relative;
          display: flex;
          justify-content: space-between;
          span,
          strong {
            z-index: 1;
            background-color: var(--white);
            min-width: initial !important;
            margin: initial !important;
          }
          span {
            padding-right: 10px;
            text-align: left;
          }
          strong {
            padding-left: 10px;
            text-align: right;
            font-weight: 700;
          }
          &::after {
            border: 1px dashed #dddddd;
            content: "";
            top: 50%;
            width: 100%;
            height: 1px;
            right: 0;
            display: block;
            position: absolute;
            z-index: 0;
          }
        }
      }
      @media only screen and (min-width: 992px) {
        .return-details-margin-top {
          margin-top: 10px;
        }
      }
    }
    @media only screen and (max-width: 991px) {
      .products-view-details {
        font-size: 14px;
      }
    }
    @media only screen and (max-width: 449px) {
      .products-view-image {
        margin-right: 20px;
        min-width: 90px;
        min-height: 90px;
        img {
          max-width: 70px;
          max-height: 70px;
        }
      }
    }
  }
  .total {
    text-align: center;
    font-weight: 700;
    border-top: 1px solid var(--border);
    padding-top: 20px;
    padding-bottom: 5px;
    margin-left: -1rem;
    margin-right: -1rem;
  }
  .cost {
    font-weight: 700;
  }
  img {
    margin-right: 0 !important;
  }
  @media only screen and (max-width: 991px) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 20px;
    border-bottom: 0;
    border-radius: 5px;
    background-color: var(--white) !important;
    .return-details {
      padding: 10px 20px;
      color: var(--white);
    }
  }
  @media only screen and (min-width: 992px) {
    &:nth-child(even) {
      .return-products {
        span,
        strong {
          background-color: var(--off-white) !important;
        }
      }
    }
  }
`;
